/**
 * kebab-case to camelCase
 * @param {string} stringKebab - string in kebab-case
 * @return {string} stringCamel
 */
export default function camelize(stringKebab: string) {
  return stringKebab.replace(/-./g, x => x[1].toUpperCase());
}
